import React from 'react';
import { Field } from 'formik';

import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';

import styles from './coverLetterFieldStyles';

const CoverLetterField = () => (
  <div className={styles.container}>
    <p className={styles.subHeader}>
      <strong>Cover Letter - </strong>
      Explain why you feel you would be a good fit for the position based on the job requirements
      and the information laid out in your profile
    </p>
    <Field component={InputField} type="textarea" name="coverLetter" />
  </div>
);

export default CoverLetterField;
